<script setup lang="ts">
    import type { IntroWidgetData } from '~/@types/cms';
    import type { IWidgetProps } from '~/composables/widgets';

    const props = defineProps<IWidgetProps<IntroWidgetData>>();
    useProvideWidgetInfo(props);
</script>
<template>
    <mol-intro
        class="cms-intro-widget"
        :intro="data.value"
        :anchor="data.anchor">
        <div
            v-if="data.link || data.link2"
            class="flex flex-wrap justify-center gap-5">
            <atm-link
                v-if="data.link"
                :link="data.link"
                styling="solid-secondary" />
            <atm-link
                v-if="data.link2"
                :link="data.link2"
                styling="outline" />
        </div>
    </mol-intro>
</template>
